// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"styles-module__dropdown___2tXAy","double-width-dropdown":"styles-module__double-width-dropdown___1Pg5b"};